import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import Button from "../components/Button";
import { festival } from "../data/festival";
import styles from "./Vending.module.css";

const subNav = [
  { label: "Participate", path: "/participate", end: true },
  { label: "Get Involved", path: "/participate/get-involved" },
  { label: "Vending", path: "/participate/vending" },
  { label: "Sponsors", path: "/participate/sponsors" },
];

const tiers = [
  { name: "Food Vendor", fee: "$650", note: "$1M liability insurance required" },
  { name: "Goods Vendor", fee: "$350", note: "Soft goods, art, retail" },
  { name: "Sponsor Booth", fee: "Free", note: "For sponsors at $1,000+" },
  { name: "Non-Profit", fee: "Free", note: "With approval — social, charity, environmental, outdoor" },
];

const hours = [
  { day: "Friday", time: "2:00 PM – 10:30 PM" },
  { day: "Saturday", time: "10:00 AM – 11:00 PM" },
  { day: "Sunday", time: "10:00 AM – 7:30 PM" },
];

export default function Vending() {
  return (
    <>
      <PageHero
        eyebrow="Bring your booth to the river"
        title="Vending"
        lede="Food, goods, and nonprofit booths under the cottonwoods. Three days, one mainstage, one captive audience."
        image="/photos/festival-2.jpg"
      />
      <SubNav items={subNav} />

      <Page>
        <div className={styles.alert}>
          <strong>2026 vending is sold out.</strong> Drop us a note to get on the
          list for 2027 and to be notified if any spots free up.
          <Button href={`mailto:${festival.emailVendor}`} variant="dark" size="sm" className={styles.alertCta}>
            Email {festival.emailVendor}
          </Button>
        </div>

        <h2 className={styles.h2}>Booth Fees</h2>
        <div className={styles.tiers}>
          {tiers.map((t) => (
            <div key={t.name} className={styles.tier}>
              <div className={styles.tierFee}>{t.fee}</div>
              <div className={styles.tierName}>{t.name}</div>
              <div className={styles.tierNote}>{t.note}</div>
            </div>
          ))}
        </div>

        <h2 className={styles.h2}>What to Bring</h2>
        <ul className={styles.list}>
          <li>Approximately 10' × 10' space — bring your own tent, tables, and lighting</li>
          <li>Three sides and a wind/rain-resistant roof</li>
          <li>Power source (solar / battery — generators are not permitted)</li>
          <li>Food vendors: $1,000,000 liability insurance covering July 31 – August 2, 2026</li>
        </ul>

        <h2 className={styles.h2}>Schedule</h2>
        <ul className={styles.schedule}>
          <li><strong>Setup deadline</strong> — no later than 5:00 PM, Thursday, July 30, 2026</li>
          <li><strong>Required participation</strong> — all three festival days</li>
          {hours.map((h) => (
            <li key={h.day}><strong>{h.day}</strong> — {h.time}</li>
          ))}
        </ul>

        <div className={styles.contact}>
          <h3>Questions?</h3>
          <p>
            Reach out at <a href={`mailto:${festival.emailVendor}`}>{festival.emailVendor}</a>.
          </p>
        </div>
      </Page>
    </>
  );
}
